module.exports = __webpack_public_path__ + "static/img/criterion1.7f84f06c.png";